export default __webpack_public_path__ + "static/media/1507529757-8532.64e83766.jpg";